import styled from "styled-components";

export const LandingAnimatedImageRoot = styled("div")<{}>(() => {
  return {
    position: "relative",
  };
});

export const LandingAnimatedBound = styled.button<{
  $w: number;
  $h: number;
  $sourceImage: string | undefined;
}>(({ $sourceImage, $h, $w }) => {
  return {
    position: "absolute",
    background: "transparent",
    border: 0,
    outline: "none !important",
    padding: 0,
    margin: 0,
    "&:after": {
      content: '" "',
      display: "inline-block",
      backgroundSize: "contain",
      width: $w,
      height: $h,
      backgroundImage: `url(${$sourceImage})`,
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    },
  };
});
